import PropTypes from 'prop-types'
import classNames from 'classnames'

import classes from './Switcher.module.scss'

const Switcher = ({ isSwitched, onClick, options, className }) => (
  <button
    type='button'
    className={classNames('d-flex justify-content-center align-items-center', classes.button, className)}
    onClick={onClick}
  >
    <span className={classNames(classes.option, { [classes.switchSelected]: !isSwitched })}>{options[0]}</span>
    <span className={classNames(classes.option, { [classes.switchSelected]: isSwitched })}>{options[1]}</span>
  </button>
)

Switcher.propTypes = {
  isSwitched: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
  options: PropTypes.arrayOf(PropTypes.string).isRequired,
  className: PropTypes.string,
}

export default Switcher
